import React from "react";

const BookingStats = ({ Data }) => {
  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
        <div className="bg-white rounded-lg p-5 space-y-1">
          <div>
            <p className="text-sm text-gray-500">Todays Hotel Bookings</p>
          </div>
          <div>
            <p className="text-2xl font-bold">
              {Data?.todayHotelBookings || 0}
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 space-y-1">
          <div>
            <p className="text-sm text-gray-500">Total Hotel Bookings</p>
          </div>
          <div>
            <p className="text-2xl font-bold">
              {Data?.totalHotelBookings || 0}
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 space-y-1">
          <div>
            <p className="text-sm text-gray-500">Todays Tour Bookings</p>
          </div>
          <div>
            <p className="text-2xl font-bold">{Data?.todayTourBookings || 0}</p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 space-y-1">
          <div>
            <p className="text-sm text-gray-500">Todays Total Bookings</p>
          </div>
          <div>
            <p className="text-2xl font-bold">{Data?.totalTourBookings || 0}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingStats;
